import { EERIE } from 'HubStyleTokens/colors';
import { WEB_FONT_DEMI_BOLD_WEIGHT } from 'HubStyleTokens/misc';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIButton from 'UIComponents/button/UIButton';
import { H3 } from 'UIComponents/elements/headings';
import UIIcon from 'UIComponents/icon/UIIcon';
import { useState } from 'react';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { ExpandSectionButtonContainer, ExpandableSectionContent, ExpandableSectionLabel } from 'ui-addon-upgrades/featureTable/ExpandableSection';
import { Table } from 'ui-addon-upgrades/featureTable/FeatureTable';
import ProductIcon from '../../components/common/ProductIcon';
import { getEnrolledProductLineFeatureAccessLevels, getFeaturesAtProductLevel } from '../../components/feature-table/CommerceFeatureTableConfig';
import CommerceFeatureTableRow from '../../components/feature-table/CommerceFeatureTableRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CommerceHubBody = () => {
  const levels = ['FREE', 'STARTER'];
  const accessLevels = getEnrolledProductLineFeatureAccessLevels(COMMERCE);
  const features = getFeaturesAtProductLevel(COMMERCE, levels);
  const [isFeatureContentExpanded, setIsFeatureContentExpanded] = useState(false);
  return /*#__PURE__*/_jsxs(Table, {
    className: "width-100",
    children: [/*#__PURE__*/_jsx(ExpandableSectionLabel, {
      className: "display-flex",
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          colSpan: 3,
          children: /*#__PURE__*/_jsx(H3, {
            style: {
              padding: '0 42px',
              marginBottom: 0,
              fontSize: 20,
              fontWeight: WEB_FONT_DEMI_BOLD_WEIGHT
            },
            children: /*#__PURE__*/_jsxs("div", {
              className: "display-flex align-center",
              style: {
                marginLeft: '-24px'
              },
              children: [/*#__PURE__*/_jsx(ProductIcon, {
                productLine: COMMERCE,
                width: "24",
                className: "m-right-3"
              }), /*#__PURE__*/_jsx("strong", {
                children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                  message: "suiteFeatureTable.section.title",
                  options: {
                    product: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: `productLine.COMMERCE`
                    })
                  }
                })
              })]
            })
          })
        })
      })
    }, `feature-table-commerce-section-label`), /*#__PURE__*/_jsx(ExpandableSectionContent, {
      id: `suite-feature-table-${COMMERCE}-section`,
      isFeatureContentExpanded: isFeatureContentExpanded,
      className: isFeatureContentExpanded ? 'expanded' : 'collapsed',
      hideFeatureContentExpandedButton: false,
      numberOfRowsToShow: 5,
      children: features.map(feature => {
        return /*#__PURE__*/_jsx(CommerceFeatureTableRow, {
          productLevels: levels,
          accessLevels: accessLevels,
          feature: feature,
          isSuite: true,
          style: {
            fontWeight: 'normal',
            marginLeft: '-18px'
          }
        }, feature.shortName);
      })
    }), /*#__PURE__*/_jsx(ExpandSectionButtonContainer, {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("td", {
          colSpan: 3,
          className: "display-flex align-center",
          children: /*#__PURE__*/_jsxs(UIButton, {
            use: "transparent",
            onClick: () => {
              setIsFeatureContentExpanded(!isFeatureContentExpanded);
            },
            "aria-expanded": !!isFeatureContentExpanded,
            className: "p-left-0",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: isFeatureContentExpanded ? `suiteFeatureTable.collapse` : `suiteFeatureTable.expand`
            }), /*#__PURE__*/_jsx(UIIcon, {
              name: isFeatureContentExpanded ? 'up' : 'down',
              color: EERIE,
              size: "xxs"
            })]
          })
        })
      })
    })]
  });
};
export default CommerceHubBody;